<template>
    <div>
      <h2 class="mb-4 text-danger">Eliminar Sala de Cultivo</h2>
      <p>¿Estás seguro de que deseas eliminar la sala de cultivo <strong>{{ sala.nombre }}</strong>?</p>
      <p>Esta acción no se puede deshacer.</p>
  
      <div class="d-flex gap-2">
        <button @click="confirmarEliminacion" class="btn btn-danger">Eliminar</button>
        <button @click="$emit('accionTerminada')" class="btn btn-secondary">Cancelar</button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    props: {
      sala: {
        type: Object,
        required: true,
      },
    },
    methods: {
      async confirmarEliminacion() {
        try {
          await axios.delete(`/api/salasDeCultivo/${this.sala.id}`);
          alert('Sala de cultivo eliminada con éxito');
          this.$emit('accionTerminada');
        } catch (error) {
          alert(error.response.data.message || 'Error al eliminar la sala de cultivo');
          console.error('Error al eliminar la sala de cultivo:', error);
          this.$emit('accionTerminada');

        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos para este componente si es necesario */
  </style>
  